var React = require('react');

function IconMailSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M82 213.8c-9 0-16.2 7.3-16.2 16.2l.4 73.2-.4 417.4v73.2c0 8.9 7.2 16.2 16.3 16.2h861c9 0 16.3-7.3 16.3-16.2V230c0-8.9-7.2-16.2-16.3-16.2H82zm788 187.5L512.5 624.7 155.1 401.3V312l357.4 223.4L870 312v89.3z"}));
}

IconMailSolid.displayName = "IconMailSolid";

IconMailSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconMailSolid;

IconMailSolid.default = IconMailSolid;
